export const ALERTS_SLICE_NAME = "alerts"
